


















































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import {
  ReminderModel,
  RemindersClient,
  DistributorsClient,
} from "@/diamond-support-api";
import { Action, State } from "vuex-class";
import PopUp from "@/components/app/PopUp.vue";
import RemoveItemDialog from "@/components/app/RemoveItemDialog.vue";
import { ErrorMessage, SuccessMessage, SystemMessage } from "@/shared";

@Component({
  components: {
    RemoveItemDialog,
    PopUp,
  },
})
export default class UrgentReminderList extends Vue {
  @Action("showMessage", { namespace: "notification" }) showMessage: any;
  items: ReminderModel[] = [];
  reminders: ReminderModel[] = [];
  urgentReminders: ReminderModel[] = [];
  reminder: ReminderModel = new ReminderModel();
  urgentReminder: ReminderModel = new ReminderModel();
  remindersApi = new RemindersClient();
  distributorNoteApi = new DistributorsClient();

  search = "";
  shownUrgentReminderList = true;

  removeItem: ReminderModel | null = null;
  removeMessage = "";
  showRemoveDialog = false;

  showCompletePopUp = false;
  completeMessage = "";
  completeItem: ReminderModel | null = null;

  headers: any[] = [
    {
      text: "Distributor Id",
      value: "distributorId",
      align: "center",
    },
    {
      text: "Content",
      value: "content",
      width: "35%",
    },
    {
      text: "Updated time",
      value: "updatedUtc",
      sortable: false,
      align: " d-none",
    },
    {
      text: "Due On",
      value: "dueOnUtc",
      sortable: false,
    },
    {
      text: "Edit",
      align: "center",
      sortable: false,
      value: "edit",
    },
    {
      text: "Delete",
      align: "center",
      sortable: false,
      value: "delete",
    },
    {
      text: "Complete",
      align: "center",
      sortable: false,
      value: "complete",
    },
  ];

  async mounted() {
    this.items = await this.remindersApi.getAll();
    this.reminders = this.items.filter((elem) => elem.dueOnUtc! > new Date());
    this.urgentReminders = this.reminders.filter(
      (elem) => elem.isUrgent == true && elem.completedOnUtc == null
    );
  }

  editReminder(id: string) {
    this.$router.push({
      path: `/userDashboard/urgentReminderList/${id}/reminderEdit`,
    });
  }

  removeReminder(urgentReminder: ReminderModel) {
    this.removeItem = urgentReminder;
    this.removeMessage = `Are you sure you want to remove the urgent reminder for distributor Id ${urgentReminder.distributorId} ?`;
    this.showRemoveDialog = true;
  }

  completeReminder(urgentReminder: ReminderModel) {
    this.completeItem = urgentReminder;
    this.completeMessage = `Are you sure you want to complete the urgent reminder for distributor Id ${urgentReminder.distributorId} ?`;
    this.showCompletePopUp = true;
  }

  customSort() {
    return this.urgentReminders.sort((a, b) => {
      return <any>new Date(b.updatedUtc!) - <any>new Date(a.updatedUtc!);
    });
  }

  closePopUp() {
    this.$router.push({
      path: `/userDashboard`,
    });
  }

  reminderUpdated(urgentReminder: ReminderModel) {
    let index = this.urgentReminders!.map(function (x) {
      return x.id;
    }).indexOf(urgentReminder.id);
    if (index >= 0) this.urgentReminders!.splice(index, 1, urgentReminder);
  }

  reminderRemoved(urgentReminder: ReminderModel) {
    let index = this.urgentReminders!.map(function (x) {
      return x.id;
    }).indexOf(urgentReminder.id);
    if (index >= 0) this.urgentReminders!.splice(index, 1);
  }

  reminderCompleted(urgentReminder: ReminderModel) {
    let index = this.urgentReminders!.map(function (x) {
      return x.id;
    }).indexOf(urgentReminder.id);
    if (index >= 0) this.urgentReminders!.splice(index, 1, urgentReminder);
  }

  async confirmRemove() {
    if (this.removeItem) {
      await this.remindersApi
        .delete(this.removeItem)
        .then((response) => {
          if (response !== null) this.reminderRemoved(this.removeItem!);
          this.showMessage(new SuccessMessage(`Reminder has been deleted.`));
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    this.reminderRemoved(this.removeItem!);
    this.showRemoveDialog = false;
  }

  async confirmCompleteUrgentReminder(reminder: ReminderModel) {
    if (this.completeItem) {
      this.completeItem.completedOnUtc = new Date();
      await this.remindersApi
        .put(this.completeItem)
        .then((response) => {
          if (response !== null) this.reminderCompleted(this.completeItem!);
          this.showMessage(new SuccessMessage(`Reminder has been completed.`));
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    this.showCompletePopUp = false;
  }
}
